import { gql } from "@apollo/client";

export const GET_MASTER_DATA_RETAILERS = gql`
  query MasterDataRetailers($params: MasterDataRetailersParamsInput!) {
    masterDataRetailers(params: $params) {
      total
      page
      limit
      items {
        retailerId
        retailerKey
        retailerName
        matchRulesCount
        rawAssociationsCount
      }
    }
  }
`;
